/* Packages */
import React from "react";
import Resizer from 'react-image-file-resizer';
import SimpleValue from "@webstores/webstores-configurator/dist/inputs/abstracts/SimpleValue";

/* Images */
import placeholder from 'img/placeholders/image-upload-placeholder.svg';

export default function ImageUpload({
    stepData,
    setStepData,
    input,
    field,
    preventUpdate = true,
}) {
    /* Render */
    return (
        <SimpleValue
            input={input}
            stepData={stepData}
            setStepData={setStepData}
            preventUpdate={preventUpdate}
            field={field}>
            {({ updateValue }) => {
                return (
                    <label className="card">
                        <input
                            className="d-none"
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                                if (!e.target.files?.length) return updateValue('');
                                Resizer.imageFileResizer(
                                    e.target.files?.[0],
                                    1920,
                                    1920,
                                    'JPEG',
                                    90,
                                    0,
                                    (uri) => updateValue(uri),
                                    'base64',
                                );

                            }}
                            onClick={(e) => {
                                if (!input.value) return;
                                e.preventDefault();
                                e.target.value = null;
                                updateValue('');
                            }}
                        />
                        <div className="card-body d-flex flex-lg-column align-items-center gap-3 text--14 p-2 pr-4 p-lg-5">
                            <img src={input.value || placeholder} width="60" height="40" className="object-fit-cover rounded" />
                            <span className="order-lg-first mr-auto mr-lg-0 text-truncate">{input.label}</span>
                            {input.value ?
                                (
                                    <span className="text-danger">Verwijderen</span>
                                )
                                :
                                (
                                    <span className="text-muted--40">Uploaden</span>
                                )
                            }
                        </div>
                    </label>
                );
            }}
        </SimpleValue>
    );
}
